// extracted by mini-css-extract-plugin
module.exports = {"list":"the-academic-background_list_uORbJ","item":"the-academic-background_item_2F20V","content":"the-academic-background_content_1vp3o"};